<template>
  <div style="width: 25%;">
    <div style="width:100%  display: flex;" class="item">
      <span>客资来源金额</span>
      <div id="item" style="width:100%; height:400px
      ">
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  props: {
    list8: Array
  },
  name: "",
  data () {
    return {

    }
  },
  mounted () {
    this.initBie()
  },
  methods: {
    initBie () {
      let chartDom = document.getElementById('item');
      let myChart = echarts.init(chartDom);
      let option;

      option = {
        color: ['#fc8452', '#5087EB','#73c0de'],
        title: {
          text: '',
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left'
        },
        series: [
          {
            // name: 'Access From',
            type: 'pie',
            radius: '50%',
            data:this.list8,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      };

      option && myChart.setOption(option);
      window.onresize = function () {
        myChart.resize();
      }
    }
  },
  watch: {
    list8: {
      deep: true,
      handler (val) {
        this.initBie()
      },
    },
  },
  components: {

  },
}
</script>

<style scoped></style>




// WEBPACK FOOTER //
// src/statistics/components/income7.vue